var errs = {};
export var onError = function (sendParams, ns) {
    if (ns === void 0) { ns = 'jserrs'; }
    var oldOnError = window.onerror;
    window.onerror = function (message, file, line, column, err) {
        var msg = message == 'Script error.' ? 'Script error' : message;
        var fileWithPos;
        if (typeof file == 'string' && typeof line == 'number' && typeof column == 'number') {
            fileWithPos = [file, line, column].join(':');
        }
        var stack = err && typeof err.stack == 'string' && err.stack.replace(/\n/g, '\\n');
        if (stack && stack.length > 2000) {
            stack = stack.substr(0, 1000) + '\\n...\\n' + stack.substr(-1000);
        }
        var params = [
            ns,
            param(PACKAGE_VERSION),
            param(msg),
            param(location.host + location.pathname),
            param(typeof file == 'string' && file),
            param(fileWithPos),
            param(stack),
            '1',
            1,
        ];
        // @ts-ignore
        var key = [msg, file, fileWithPos].join('|');
        if (!errs[key]) {
            errs[key] = true;
            sendParams(params, arguments);
        }
        if (typeof oldOnError == 'function') {
            return oldOnError.apply(window, arguments);
        }
    };
};
function param(value) {
    var result = value ? String(value) : 'none';
    if (result.length > 20) {
        result = '[' + fnv32(result).toString(36) + ']' + result;
    }
    return result;
}
function fnv32(str) {
    var hval = 0x811c9dc5;
    for (var i = 0, len = str.length; i < len; ++i) {
        hval ^= str.charCodeAt(i);
        hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
    }
    return hval >>> 0;
}
